class UTM {
  constructor() {
    this.url = new URL(window.location.href);
    this.elIframeForms = document.querySelectorAll('.utm-form');
    this.data = {};
    this.init();
    this.debug();
  }

  init() {
    this.handleUtmValues();
    this.handleIframeForms();
  }

  // TODO: Refactor
  handleUtmValues() {

    if (this.utmValuesExist()) {
      // Check if utm cookie exists
      if (Helper.getCookie('utm_cookie')) {

        // Check if the cookie's utm values have changed.
        if (Helper.getCookie('utm_cookie') != JSON.stringify(this.data)) {
          console.log('The utm_cookie value has changed! Updating utm_cookie.');
          this.createCookie();
        }

      } else {
        this.createCookie();
      }
    }

  }

  /**
   * Populate local wufoo iframe form src attributes with utm values.
   */
  handleIframeForms() {
    if (!this.elIframeForms) return;

    // Modify the src attribute of each local wufoo iframe.
    this.elIframeForms.forEach( iframeForm => {
      iframeForm.dataset.src = iframeForm.dataset.src + '?' + UTM.getUTMValueString();

      // Initialize new instance of lazyload targetting only wufoo iframe forms.
      new LazyLoad({
        elements_selector: ".utm-form",
      });
    });
  }

  createCookie() {
    let date = new Date();
    let days = 365;
    date.setTime(date.getTime() + (days * 86400000)) // 24 * 60 * 60 * 1000
    document.cookie = 'utm_cookie=' + JSON.stringify(this.data) + '; expires=' + date.toGMTString();
  }

  /**
   * 
   * @param {String} utm_campaign_field 
   * @param {String} utm_content_field 
   */
  static getUTMValueString(
    utm_campaign_field = 'Field3',
    utm_content_field = 'Field5',
    utm_medium_field = 'Field2',
    utm_source_field = 'Field1',
    utm_term_field = 'Field4',
    referring_page_field = 'Field7') {

    let UTMCookie = false;

    try {
      UTMCookie = Helper.getCookie('utm_cookie') ? JSON.parse(Helper.getCookie('utm_cookie')) : false;
    } catch (error) {
      console.log(error);
    }
  
    let referring_page = location.host + location.pathname;
    let utm_campaign = '';
    let utm_content = '';
    let utm_medium = '';
    let utm_source = '';
    let utm_term = '';

    if (UTMCookie !== null && UTMCookie !== false) {
      utm_campaign = UTMCookie.utm_campaign !== false &&
                        UTMCookie.utm_campaign !== undefined ? UTMCookie.utm_campaign : 'Organic/Referral';

      utm_content = UTMCookie.utm_content !== false &&
                        UTMCookie.utm_content !== undefined ? UTMCookie.utm_content : 'Organic/Referral';

      utm_medium = UTMCookie.utm_medium !== false &&
                      UTMCookie.utm_medium !== undefined ? UTMCookie.utm_medium : 'Organic/Referral';

      utm_source = UTMCookie.utm_source !== false &&
                      UTMCookie.utm_source !== undefined ? UTMCookie.utm_source : 'Organic/Referral';

      utm_term = UTMCookie.utm_term !== false &&
                    UTMCookie.utm_term !== undefined ? UTMCookie.utm_term : 'Organic/Referral';
    } else {
      utm_campaign = 'Organic/Referral';
      utm_content = 'Organic/Referral';
      utm_medium = 'Organic/Referral';
      utm_source = 'Organic/Referral';
      utm_term = 'Organic/Referral';
    }

    // Create UTM value string
    let values = '';
    values += utm_campaign_field + '=' + utm_campaign;
    values += '&' + utm_content_field + '=' + utm_content;
    values += '&' + utm_medium_field + '=' + utm_medium;
    values += '&' + utm_source_field + '=' + utm_source;
    values += '&' + utm_term_field + '=' + utm_term;
    values += '&' + referring_page_field + '=' + referring_page;

    return values;
  }

  /**
   * Check if all UTM parameters exist in the url
   */
  utmValuesExist() {
    let utm_source = null;
    let utm_campaign = null;
    let utm_medium = null;
    let utm_term = null;
    let utm_content = null;

    if (Helper.isInternetExplorer()) {
      utm_source = Helper.getParameterByName('utm_source', this.url.href);
      utm_campaign = Helper.getParameterByName('utm_campaign', this.url.href);
      utm_medium = Helper.getParameterByName('utm_medium', this.url.href);
      utm_term = Helper.getParameterByName('utm_term', this.url.href);
      utm_content = Helper.getParameterByName('utm_content', this.url.href);
    } else {
      utm_source = this.url.searchParams.get('utm_source');
      utm_campaign = this.url.searchParams.get('utm_campaign');
      utm_medium = this.url.searchParams.get('utm_medium');
      utm_term = this.url.searchParams.get('utm_term');
      utm_content = this.url.searchParams.get('utm_content');
    }

    this.data.utm_source = utm_source !== null ? utm_source : false;
    this.data.utm_campaign = utm_campaign !== null ? utm_campaign : false;
    this.data.utm_medium = utm_medium !== null ? utm_medium : false;
    this.data.utm_term = utm_term !== null ? utm_term : false;
    this.data.utm_content = utm_content !== null ? utm_content : false;

    if (this.data.utm_source ||
        this.data.utm_campaign ||
        this.data.utm_medium ||
        this.data.utm_term ||
        this.data.utm_content) {
      return true;
    }

    return false;
  }

  debug() {
    if (debug) {
      console.groupCollapsed('%c Header', 'color: #bada55');
      console.log(this);
      console.groupEnd();
    }
  }
}